<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        d="M410.5 916.6c-39.6-.2-78-7.6-114-22.1-37.8-15.2-71.5-37.4-100.2-65.8-28.8-28.5-51.2-61.8-66.5-99.1-14.8-35.8-22.3-73.7-22.4-112.7-.1-38.9 7.2-76.8 21.8-112.7 15.2-37.3 37.5-70.6 66.1-98.9l293-289.8c5.2-5.2 12.2-8 19.6-8 7.4 0 14.4 2.9 19.7 8.1 5.3 5.1 8.1 12 8.1 19.4 0 7.3-2.9 14.2-8.2 19.4L234.6 444c-46.4 45.8-71.8 107.2-71.7 172.7.1 65.5 25.9 127 72.6 173.2 46.7 46.1 108.9 71.6 175.2 71.8h.7c66 0 127.8-25.1 174.2-70.7l227-224.6c31.6-31.2 48.9-73 48.8-117.7-.1-44.7-17.7-86.6-49.5-118.2-31.9-31.5-74.4-48.8-119.6-48.9h-.5c-45.1 0-87.3 17.2-118.7 48.3L359 541.4c-13.3 13.1-20.5 30.6-20.4 49.3 0 18.7 7.4 36.3 20.8 49.6 13.2 13.2 31.1 20.5 50.2 20.6h.1c18.9 0 36.6-7.2 49.7-20.2l187.7-185.5c5.2-5.2 12.2-8 19.6-8 7.5 0 14.5 2.8 19.6 8 5.3 5.1 8.2 12 8.2 19.4 0 7.3-2.9 14.2-8.2 19.4L498.7 679.5c-23.7 23.4-55.3 36.2-88.9 36.2h-.3c-33.7-.1-65.4-13.1-89.3-36.7-23.8-23.6-37-54.9-37.1-88.3-.1-33.5 12.9-64.8 36.6-88.3l214-211.4c21.3-21 46.2-37.3 74.1-48.4 26.8-10.6 55-16 83.8-16h.6c59.9.1 116.2 23.2 158.6 65.1 42.2 41.7 65.6 97.4 65.8 156.7.1 28.6-5.3 56.7-16.2 83.5-11.1 27.4-27.5 52-48.9 73.3l-227 224.5c-28.7 28.4-62.3 50.4-100 65.3-35.9 14.3-74 21.6-113.2 21.6h-.8z"
        data-follow-fill="currentColor"
        :fill="_fill"
      />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
